import de from './de/translations.json';
import en from './en/translations.json';
import fr from './fr/translations.json';
import es from './es/translations.json';
import it from './it/translations.json';
export default {
  de,
  en,
  fr,
  es,
  it
};